import "./styles.scss";

import { useTranslation } from "react-i18next";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import useResponsive from "libs/helpers/useResponsive";

import { useUsers } from "context/admin/users";
import { UsersTable, UsersTiles } from "./components";

const mainClass = "users-admin-content";

const actions = [
  {
    type: "send_notification",
  },
  {
    type: "create_task",
  },
];

const UsersContent = () => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  const { data, loading, init_loading, filters, filterHandler } = useUsers();

  return (
    <DashboardContentLayout
      header={{
        label: t("All users"),
        description: t("Accounts registered in the system."),
      }}
      loading={init_loading}
      actions={actions}
    >
      <div className={mainClass}>
        {!max.lg ? (
          <UsersTable
            data={data}
            loading={!!loading}
            sort={filters?.sort}
            setSort={(value) => filterHandler("sort", value)}
          />
        ) : (
          <UsersTiles data={data} loading={!!loading} />
        )}
      </div>
    </DashboardContentLayout>
  );
};

export default UsersContent;
